<mat-icon *ngIf="!isUpDown" svgIcon="icon-basic-switch"></mat-icon>
<!-- [ngClass]="{'up-down': isUpDown}" -->
<mat-icon *ngIf="isUpDown" svgIcon="icon-resize-vertical"></mat-icon>